import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const fmtWeek = (iso) => new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "short", timeZone: "UTC" });

export default function ClaimLinkAnalytics({ refreshKey }) {
  const [data, setData] = useState(null);
  const [weeks, setWeeks] = useState(8);
  useEffect(() => { api.get(`/admin/free-listings/claim-analytics?weeks=${weeks}`).then(({ data }) => setData(data)).catch(() => {}); }, [refreshKey, weeks]);
  if (!data) return null;
  const t = data.totals;
  const cells = [
    { key: "landed", label: "Landed", hint: "mailer link opened", value: t.landed, cls: "text-[#11211A]" },
    { key: "auto_sent", label: "Auto-sent", hint: "magic link emailed", value: t.auto_sent, cls: "text-[#264839]" },
    { key: "completed", label: "Completed", hint: "listing claimed", value: t.completed, cls: "text-[#B8860B]" },
    { key: "rate", label: "Completion", hint: "completed ÷ landed", value: `${t.completion_rate}%`, cls: "text-[#11211A]" },
  ];
  return (
    <div className="bg-white border border-[#E8ECE9] p-6" data-testid="claim-link-analytics">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
        <div>
          <div className="font-serif text-xl text-[#11211A]">Claim link analytics</div>
          <p className="text-xs text-[#7D8C85] mt-0.5">Weekly mailer claim links: landed → magic link auto-sent → claim completed. Unique suppliers per week, since {fmtWeek(data.since)}.</p>
        </div>
        <div className="flex items-center gap-2">
          {[4, 8, 12].map((w) => (
            <button key={w} type="button" onClick={() => setWeeks(w)} className={`text-[10px] uppercase tracking-wider px-2.5 py-1 border transition ${weeks === w ? "bg-[#264839] text-white border-[#264839]" : "border-[#C4CFC9] text-[#4A5550] hover:border-[#264839]"}`} data-testid={`claim-analytics-range-${w}`}>{w} wks</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
        {cells.map((c) => (
          <div key={c.key} className="bg-[#FAFAF7] border border-[#E8ECE9] px-4 py-3" data-testid={`claim-analytics-total-${c.key}`}>
            <div className={`font-serif text-2xl ${c.cls}`}>{c.value}</div>
            <div className="text-[10px] uppercase tracking-wider text-[#7D8C85]">{c.label}</div>
            <div className="text-[10px] text-[#9AA6A0]">{c.hint}</div>
          </div>
        ))}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="claim-analytics-table">
          <thead>
            <tr className="text-[10px] uppercase tracking-wider text-[#7D8C85] border-b border-[#E8ECE9]">
              <th className="text-left py-2 pr-3 font-medium">Week of</th>
              <th className="text-right py-2 px-3 font-medium">Landed</th>
              <th className="text-right py-2 px-3 font-medium">Auto-sent</th>
              <th className="text-right py-2 px-3 font-medium">Organic sent</th>
              <th className="text-right py-2 px-3 font-medium">Completed</th>
              <th className="text-right py-2 pl-3 font-medium">Completion</th>
            </tr>
          </thead>
          <tbody>
            {[...data.weeks].reverse().map((w) => (
              <tr key={w.week_start} className="border-b border-[#F0EFEA] text-[#11211A]" data-testid={`claim-analytics-week-${w.week_start}`}>
                <td className="py-2 pr-3 whitespace-nowrap">{fmtWeek(w.week_start)}</td>
                <td className="py-2 px-3 text-right tabular-nums">{w.landed}</td>
                <td className="py-2 px-3 text-right tabular-nums text-[#264839]">{w.auto_sent}</td>
                <td className="py-2 px-3 text-right tabular-nums text-[#7D8C85]">{w.organic_sent}</td>
                <td className="py-2 px-3 text-right tabular-nums text-[#B8860B] font-medium">{w.completed}</td>
                <td className="py-2 pl-3 text-right tabular-nums">{w.landed ? `${w.completion_rate}%` : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
